export function addSameCodeForAllHospitals(hospitals, code) {
  return hospitals.map((hospital) => ({ ...hospital, pepId: code }));
}
